const LOCALSTORAGE_KEY = 'visitedItems'

/**
 * @returns {string[]} Array of item IDs
 */
export const getLastVisitedItemIds = () => {
  try {
    const serializedState = (localStorage.getItem && localStorage.getItem(LOCALSTORAGE_KEY)) || '[]'
    return JSON.parse(serializedState)
  } catch (error) {
    console.warn('localStorage error', error)
    return []
  }
}

const persistVisitedItems = (visitedItems) => {
  try {
    localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(visitedItems))
  } catch (error) {
    console.warn('localStorage error', error)
  }
}

export const saveItemVisit = (itemId) => {
  const existingIds = getLastVisitedItemIds()
  const filteredIds = existingIds.filter((id) => id !== itemId)
  const visitedItems = [itemId, ...filteredIds].slice(0, 20) // max length of 20
  persistVisitedItems(visitedItems)
}

export const clearLastVisitedItems = () => {
  try {
    localStorage.removeItem(LOCALSTORAGE_KEY)
  } catch (error) {
    console.warn('localStorage error', error)
  }
}
